// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://pxitouotodcircmvangu.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB4aXRvdW90b2RjaXJjbXZhbmd1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDkwNDU5MjYsImV4cCI6MjA2NDYyMTkyNn0.lvmaEvbWz08G7lj5fQCHMCWr9lwTAU81i2sVCcNkfuc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);